module.exports = __webpack_public_path__ + "static/media/ecpy.3e5917b5.png";